import axios from "axios";
import { Message } from "element-ui";
const baseUrl = "http://jcapi.th.520ban.com";
// 创建一个axios实例
const service = axios.create({
  // 请求超时时间
  timeout: 50000, // 请求超时时间
  withCredentials: true, // 跨域
});
// 添加请求拦截器
service.interceptors.request.use((config) => {
  // let token = sessionStorage.getItem('Token') || "";
  let userInfo = JSON.parse(localStorage.getItem("userInfo"));
  let oid = JSON.parse(localStorage.getItem("orgInfo"))?.oid || "";
  config.headers["OID"] = oid;
  // if (userInfo) {
  //   return config;
  // } else {
  //   Message.warning("请先登录");
  //   location.href = "/choice";
  //   return false;
  // }na

  // config.headers['BIDDING-SOURCE'] = `pc/ext`
  // if (token) {
  //   config.headers['Authorization'] = `Bearer ${token}`
  // }
  // else{
  //   config.headers['Authorization'] = "eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkIjoxNjAwMDg2NTc5OTQyLCJleHAiOjE2MDAwODY2NjcsInVzZXIiOiJcIjEzMDQyNjMzMjU2MTM4OTk3NzdcIiJ9._ySPcLZfjmSM2NCJKO2UYJFuHsRwhR7w5MAnx3bEfUIlE3h1kVg8siFInbhwp8SqzdzYnLu1zWOwRviHB7hiMQ";
  // }
  return config;
});

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    if (response.data.code === 1011008 || response.data.code === 1011006) {
      Message.warning("登录已过期，请刷新页面后重新登录");
      // localStorage.clear();
      localStorage.removeItem("userInfo");
      localStorage.removeItem("orgInfo");
      setTimeout(function() {
        location.href = "#/choice";
      }, 1000);
    } else {
      return response.data;
    }
  },
  (error) => {
    Message.error("数据请求异常，请联系管理员");
    return {
      data: {
        code: -9999,
        msg: "数据请求异常，请联系管理员",
      },
    };
  }
);

const api = function(url, method = "get", param) {
  if (method === "get" || method === "delete") {
    return new Promise((resolve, reject) => {
      service({
        method: method,
        url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        params: param,
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  } else if (method === "postForm") {
    return new Promise((resolve, reject) => {
      service({
        method: "post",
        url,
        data: param,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  } else {
    return new Promise((resolve, reject) => {
      service({
        method: method,
        url,
        data: param,
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};
export default {
  baseUrl,
  service,
  // get请求
  get(url, param) {
    return api(url, "get", param);
  },
  // post请求
  post(url, param) {
    return api(url, "post", param);
  },
  // put请求
  put(url, param) {
    return api(url, "put", param);
  },
  // delete请求
  delete(url, param) {
    return api(url, "delete", param);
  },
  systemIp: "api",
  Ip: "zm",
};
